var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"color":"shade-white","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('Icon',{attrs:{"color":"primary","left":"","icon":"$symbols-circle-check-outline","iconSize":"small"}}),_c('span',{staticClass:"primary--text",domProps:{"textContent":_vm._s(_vm.lc.label)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }